import { Routes } from '@angular/router';

import { getStores } from '../services/resolvers/stores';
import { Resolvers } from '../types/Resolvers';
import {
  // vehiclesResolver,
  vehicleBrandsResolver,
  vehicleModelsResolver,
  topVehiclesYearsModelsResolver,
} from '../services/resolvers/vehicles';
import { _404 } from '../pages/404/404';
import {
  getGruposProductosDestacados,
  getGruposSubcategoriasDestacados,
} from '../services/resolvers/grupos';
import { productsTopBrandsResolver } from '../services/resolvers/products';

export const routes: Routes = [
  {
    path: '',
    resolve: {
      [Resolvers.STORES]: getStores,
      [Resolvers.ALL_GROUPS_SUBCATEGORIES_DESTACED]:
        getGruposSubcategoriasDestacados,
      [Resolvers.ALL_GROUPS_PRODUCTS_DESTACED]: getGruposProductosDestacados,
      [Resolvers.ALL_VEHICLE_BRANDS]: vehicleBrandsResolver,
      [Resolvers.ALL_VEHICLE_MODELS]: vehicleModelsResolver,
      [Resolvers.ALL_PRODUCTS_TOP_BRANDS]: productsTopBrandsResolver,
    },
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/home').then((m) => m.Home),
      },
      {
        path: 'comprar',
        children: [
          {
            path: 'marca',
            loadComponent: () =>
              import('../pages/shop/comprar-por-marca').then(
                (m) => m.ComprarPorMarca
              ),
          },
          {
            path: 'modelo',
            loadComponent: () =>
              import('../pages/shop/comprar-por-modelo').then(
                (m) => m.ComprarPorModelo
              ),
          },
          {
            path: 'marca-producto',
            loadComponent: () =>
              import('../pages/shop/comprar-por-marca-producto').then(
                (m) => m.ComprarPorMarcaProducto
              ),
          },
        ],
      },
      {
        path: 'servicios',
        children: [
          {
            path: 'instalacion-filtros',
            loadComponent: () =>
              import('../pages/servicios/instalacion-filtros').then(
                (m) => m.InstalacionFiltros
              ),
          },
          {
            path: 'entrega-domicilio',
            loadComponent: () =>
              import('../pages/servicios/entrega-domicilio').then(
                (m) => m.EntregaDomicilio
              ),
          },
          {
            path: 'diagnostico-instalacion-baterias',
            loadComponent: () =>
              import(
                '../pages/servicios/diagnostico-instalacion-baterias'
              ).then((m) => m.DiagnosticoInstalacionBaterias),
          },
          {
            path: 'reciclaje-baterias',
            loadComponent: () =>
              import('../pages/servicios/reciclaje-baterias').then(
                (m) => m.ReciclajeBaterias
              ),
          },
          {
            path: 'cambiar-limpiaparabrisas',
            loadComponent: () =>
              import('../pages/servicios/cambiar-limpiaparabrisas').then(
                (m) => m.CambiarLimpiaparabrisas
              ),
          },
          {
            path: 'afiliaciones',
            loadComponent: () =>
              import('../pages/servicios/afiliaciones').then(
                (m) => m.Afiliaciones
              ),
          },
          {
            path: 'cotiza-por-whatsapp',
            loadComponent: () =>
              import('../pages/servicios/cotiza-por-whatsapp').then(
                (m) => m.CotizaPorWhatsapp
              ),
          },
          // {
          //   path: 'talleres-referidos',
          //   loadComponent: () =>
          //     import('../pages/referidos/talleres-referidos').then(
          //       (m) => m.TalleresReferidosComponent
          //     ),
          // },
        ],
      },
      // {
      //   path: 'taller/:slug',
      //   loadComponent: () =>
      //     import(
      //       '../components/talleres-referidos/selected-workshop-details-modal'
      //     ).then((m) => m.SelectedWorkshopDetailsModal),
      // },
      {
        path: 'bateria/para',
        loadComponent: () =>
          import('../pages/baterias/baterias-vehiculos').then(
            (m) => m.BateriasVehiculos
          ),
      },
      {
        path: 'bateria/para/:brand',
        loadComponent: () =>
          import('../pages/baterias/baterias-modelos').then(
            (m) => m.BateriasModelos
          ),
      },
      {
        path: 'baterias-carros-honduras',
        resolve: {
          [Resolvers.TOP_VEHICLES_YEARS_MODELS]: topVehiclesYearsModelsResolver,
        },
        loadComponent: () =>
          import('../pages/baterias/baterias-marca-modelo').then(
            (m) => m.BateriasMarcaModelo
          ),
      },
      {
        path: 'baterias/:slug',
        loadComponent: () =>
          import('../pages/baterias/baterias-slug').then((m) => m.BateriasSlug),
      },
      {
        path: 'empresa',
        children: [
          {
            path: 'sobre-nosotros',
            loadComponent: () =>
              import('../pages/about/sobre-nosotros').then(
                (m) => m.SobreNosotros
              ),
          },
          {
            path: 'bolsa-empleo',
            loadComponent: () =>
              import('../pages/about/bolsa-empleo').then((m) => m.BolsaEmpleo),
          },
        ],
      },
      // Página de Repuestos base
      {
        path: 'repuestos',
        loadComponent: () =>
          import('../pages/productos/categorias').then((m) => m.Categorias),
      },
      // Página de Repuestos base con Marca de Vehículo
      {
        path: 'repuestos/v/:marca',
        loadComponent: () =>
          import('../pages/productos/categorias').then((m) => m.Categorias),
      },
      // Página de Repuestos base con marca y modelo de Vehículo
      {
        path: 'repuestos/v/:marca/:modelo',
        loadComponent: () =>
          import('../pages/productos/categorias').then((m) => m.Categorias),
      },
      // Página de Repuestos dinámica
      {
        path: 'repuestos/:slug',
        loadComponent: () =>
          import('../pages/productos/categoria-dinamica').then(
            (m) => m.CategoriaDinamica
          ),
      },
      // Página de Repuestos dinámica con marca de Vehículo
      {
        path: 'repuestos/:slug/:marca',
        loadComponent: () =>
          import('../pages/productos/categoria-dinamica').then(
            (m) => m.CategoriaDinamica
          ),
      },
      // Página de Repuestos dinámica con marca y modelo de Vehículo
      {
        path: 'repuestos/:slug/:marca/:modelo',
        loadComponent: () =>
          import('../pages/productos/categoria-dinamica').then(
            (m) => m.CategoriaDinamica
          ),
      },
      // Página de Repuestos dinámica con marca, modelo y año de Vehículo
      {
        path: 'repuestos/:slug/:marca/:modelo/:anio',
        loadComponent: () =>
          import('../pages/productos/categoria-dinamica').then(
            (m) => m.CategoriaDinamica
          ),
      },
      // Página de Repuestos base
      {
        path: 'productos',
        loadComponent: () =>
          import('../pages/productos/products').then((m) => m.Products),
      },
      {
        path: 'productos/marca/:marcaProducto',
        loadComponent: () =>
          import('../pages/productos/products').then((m) => m.Products),
      },
      {
        path: 'productos/:slug',
        loadComponent: () =>
          import(
            '../pages/productos/producto-detalle/producto-detalle.component'
          ).then((m) => m.ProductoDetalle),
      },
      {
        path: 'productos/:slug/:vehiculo',
        loadComponent: () =>
          import(
            '../pages/productos/producto-detalle/producto-detalle.component'
          ).then((m) => m.ProductoDetalle),
      },
      {
        path: 'encuentra-tu-tienda',
        loadComponent: () =>
          import('../pages/store/encuentra-tu-tienda').then(
            (m) => m.EncuentraTuTiendaComponent
          ),
      },
      {
        path: 'garage',
        loadComponent: () =>
          import('../pages/garaje/garage').then((m) => m.Garage),
      },
      {
        path: 'garage/agregar-vehiculo',
        loadComponent: () =>
          import('../pages/garaje/agregar-vehiculo').then(
            (m) => m.AgregarVehiculo
          ),
      },
      {
        path: 'carrito',
        loadComponent: () =>
          import('../pages/cart/carrito.component').then((m) => m.Carrito),
      },
      {
        path: 'mi-tienda',
        loadComponent: () =>
          import('../pages/store/mi-tienda-page').then((m) => m.MiTiendaPage),
      },
      {
        path: 'sitemap',
        loadComponent: () =>
          import('../pages/about/sitemap').then((m) => m.Sitemap),
      },
      {
        path: 'aplicacion-movil',
        loadComponent: () =>
          import('../pages/servicios/aplicacion-movil').then(
            (m) => m.AplicacionMovil
          ),
      },
      {
        path: 'marcas',
        children: [
          {
            path: 'wagner',
            loadComponent: () =>
              import('../pages/marcas/wagner').then((m) => m.Wagner),
          },
        ],
      },
      {
        path: 'sucursales',
        loadComponent: () =>
          import('../pages/store/sucursales').then((m) => m.Sucursales),
      },
      {
        path: 'privacidad',
        loadComponent: () =>
          import('../pages/politicas/politicas.component').then(
            (m) => m.PoliticasComponent
          ),
      },
      {
        path: 'preguntas-frecuentes',
        loadComponent: () =>
          import('../pages/about/preguntas-frecuentes').then(
            (m) => m.PreguntasFrecuentes
          ),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('../pages/productos/search').then((m) => m.SearchPage),
      },
      {
        path: 'rastrear-pedido',
        loadComponent: () =>
          import('../pages/politicas/rastrear-pedido').then(
            (m) => m.RastrearPedido
          ),
      },
      {
        path: 'contactanos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/about/contactanos').then((m) => m.Contactanos),
          },
          {
            path: 'preguntas-pedidos',
            loadComponent: () =>
              import('../pages/about/contactanos/preguntas-pedidos').then(
                (m) => m.PreguntasPedidos
              ),
          },
          {
            path: 'problemas-sitio-web',
            loadComponent: () =>
              import('../pages/about/contactanos/problemas-sitio-web').then(
                (m) => m.ProblemasSitioWeb
              ),
          },
          {
            path: 'recompensas',
            loadComponent: () =>
              import('../pages/about/contactanos/recompensas').then(
                (m) => m.Recompensas
              ),
          },
          {
            path: 'repuestos-productos',
            loadComponent: () =>
              import('../pages/about/contactanos/repuestos-productos').then(
                (m) => m.RepuestosProductos
              ),
          },
          {
            path: 'garantia-productos',
            loadComponent: () =>
              import('../pages/about/contactanos/garantia-productos').then(
                (m) => m.GarantiaProductos
              ),
          },
          {
            path: 'experiencia-tienda',
            loadComponent: () =>
              import('../pages/about/contactanos/experiencia-tienda').then(
                (m) => m.ExperienciaTienda
              ),
          },
          {
            path: 'otro-asunto',
            loadComponent: () =>
              import('../pages/about/contactanos/otro-asunto').then(
                (m) => m.OtroAsunto
              ),
          },
        ],
      },
      {
        path: 'login',
        loadComponent: () =>
          import('../components/auth/main-login/main-login.component').then(
            (m) => m.MainLoginComponent
          ),
      },
      {
        path: 'bajo-construccion',
        loadComponent: () =>
          import('../pages/construccion/construccion').then(
            (m) => m.BajoConstruccion
          ),
      },
    ],
  },
  {
    path: '**',
    resolve: {
      [Resolvers.STORES]: getStores,
      [Resolvers.ALL_VEHICLE_BRANDS]: vehicleBrandsResolver,
      [Resolvers.ALL_VEHICLE_MODELS]: vehicleModelsResolver,
    },
    component: _404,
  },
];
